import { render } from "./offerreadypage.vue?vue&type=template&id=2f1286ca"
import script from "./offerreadypage.vue?vue&type=script&lang=js"
export * from "./offerreadypage.vue?vue&type=script&lang=js"

import exportComponent from "/home/julien/build/build/p2p-exchange/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__